import {
  Component,
  Directive,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'edu-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  host: {
    class: 'edu-card',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CardComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}

/**
 * Title of a card, intended for use within `<mat-card>`. This component is an optional
 * convenience for one variety of card title; any custom title element may be used in its place.
 *
 * MatCardTitle provides no behaviors, instead serving as a purely visual treatment.
 */
@Directive({
  selector: `edu-card-title, [edu-card-title], [eduCardTitle]`,
  host: { class: 'edu-card-title' },
  standalone: false,
})
export class EduCardTitle {}

/**
 * Subtitle of a card, intended for use within. This component is an optional
 * convenience for one variety of card title; any custom title element may be used in its place.
 *
 * MatCardSubTitle provides no behaviors, instead serving as a purely visual treatment.
 */
@Directive({
  selector: `edu-card-subtitle, [edu-card-subtitle], [eduCardSubTitle]`,
  host: { class: 'edu-card-subtitle' },
  standalone: false,
})
export class EduCardSubtitle {}
